import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { InsuranceService } from 'src/app/_service/insurance.service';
import { SharedService } from '../../_service/shared.service';

@Component({
  selector: 'app-insurance-company',
  templateUrl: './insurance-company.component.html',
  styleUrls: ['./insurance-company.component.css']
})
export class InsuranceCompanyComponent implements OnInit {

    @ViewChild(MatPaginator) paginator: MatPaginator;

    pageSizeOptions = [10,25,50,100,200];perpage:number=25;pageIndex:number=0;insCompList:any=[];loaded:boolean=false;loading:boolean=true;length:number=0;pageEvent: PageEvent;search:string;status='';myrole:string;

    constructor(private insuranceService: InsuranceService, private sharedapi: SharedService) { }

    ngOnInit(): void {
        this.sharedapi.getRole()
            .subscribe((item:string) => {this.myrole=item;});
            this.myrole = localStorage.getItem('role');
    }

    ngAfterViewInit() {
        this.loadInsCompList(0,this.perpage);
    }

    async loadInsCompList(pageIndex,perpage)
    {
            this.insCompList = [];
        this.paginator.pageIndex = pageIndex;
            let qString = 'search='+this.search+'&status='+this.status;
        this.loading = true;this.loaded = false;
        this.insuranceService.getAllInsCompany(this.paginator.pageIndex,perpage,qString).subscribe((data:any) => {
            this.length = parseInt(data.totaldata);
            this.loading = false;
            this.loaded = true;
            if(data.status)
            {
                this.insCompList = data.data;
            }else{
                this.insCompList = [];
            }
        }, error => {
            this.loading = false;
            this.loaded = true;
            this.sharedapi.checkError(error);
        });
    }

    public getServerData(event:PageEvent):any
    {
        this.perpage = event.pageSize;
        this.pageIndex = event.pageIndex;
        this.loadInsCompList(event.pageIndex,event.pageSize);
    }

    onStatusChange(event,id,index){
      let status=0;
      if(event.checked) status=1;
      let value = {
          'id':id,
          'status':status
      }
      this.insuranceService.updateInsCompanyStatus(value).subscribe((data:any) => {
          if(data.status)
          {
              this.sharedapi.presentToast('Status Update Successfully');
              this.insCompList[index].status=data.data.status;
          } else {
              this.sharedapi.presentToast(data.msg);
          }
      }, error => {
          this.sharedapi.checkError(error);
      });

  }
  resetFilters()
  {
      this.search = '';this.status = '';
      this.loadInsCompList(0,25);
  }
}
